import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import LoadingIndicator from "../LoadingIndicator";
import IntegrationSelect from "../IntegrationSelect/index";
import Button from "UI/Button";

import { CheckCircleIcon } from "@heroicons/react/outline";

import Modal from "UI/Modal";

const defaultState = {
    selected: {},
    busy: false,
    complete: false
};

export default class ShareDialog extends React.Component
{
    state = defaultState;

    static propTypes = {
        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,

        loading: PropTypes.bool,

        story: PropTypes.object.isRequired,

        integrations: PropTypes.object.isRequired,
        createPosts: PropTypes.func.isRequired,
    };

    static defaultProps = {
        loading: true,
    };

    selectIntegration = (id) => {
        let selected = {
            ...this.state.selected
        };

        if (id in selected) {
            delete selected[id];
        }
        else {
            selected[id] = true;
        }

        this.setState({
            selected: selected
        });
    };

    handlePostCreation = () => {
        if (! this.state.selected) {
            return null;
        }

        this.setState({busy: true, complete: false});

        const selected = _.map(this.state.selected, (isSelected, id) => {
            if (isSelected) {
                return id;
            }
        });

        this.props.createPosts(this.props.story.id, selected)
            .then(() => {
                this.setState({busy: false, complete: true});
            })
            .catch(error => {
                this.setState({busy: false, complete: false});
            });

    };

    onClose = () => {
        this.setState(defaultState, () => {
            this.props.onClose();
        });
    }

    render()
    {
        return <Modal className='max-w-md w-full' open={this.props.open} onClose={this.onClose}>
            <Modal.Header>
                Share: { this.props.story.name }
            </Modal.Header>
            {
                this.props.loading
                    && <LoadingIndicator className='mt-2 mb-6 w-8' loading/>
            }
            {
                this.state.complete
                    ? <SuccessContent />
                    : this.renderIntegrationList()
            }
            <Modal.Footer>
                {
                    this.state.complete
                        ? <>
                            <Button component={Link} to='/sharing?status=draft' type="primary">
                                View Posts
                            </Button>
                            <Button onClick={this.onClose}>Close</Button>
                        </>
                        : <>
                            <Button
                                busy={this.state.busy}
                                type={Object.keys(this.state.selected).length > 0 ? 'primary' : 'secondary'}
                                disabled={Object.keys(this.state.selected).length === 0}
                                onClick={this.handlePostCreation}
                            >Create</Button>

                            <Button onClick={this.onClose}>Cancel</Button>
                        </>
                }
            </Modal.Footer>
        </Modal>;
    }

    renderIntegrationList()
    {
        if (this.props.loading) {
            return;
        }

        const integrations = _.filter(this.props.integrations, integration => ! integration.disconnected_at);

        return <Modal.Content className='text-sm text-gray-500'>
            <p>Select which Integration to use for sharing:</p>
            <br />
            {
                integrations.length > 0
                    ? <div className='text-black'>
                        <IntegrationSelect
                            integrations={integrations}
                            selected={this.state.selected}
                            onSelect={this.selectIntegration}
                        />
                    </div>
                    : "You do not currently have any integrations setup."
            }
        </Modal.Content>;
    }
}

export const SuccessContent = () => <Modal.Content className='text-sm text-gray-500'>
    <div className='flex space-x-4'>
        <div>
            <CheckCircleIcon className='w-16 float-right text-green-400' />
        </div>
        <div>
            Hip hip hooray!<br /><br />
            We have created draft posts for each of the selected integrations.<br /><br />
        </div>
    </div>
</Modal.Content>;